import AppsIcon from '@mui/icons-material/Apps';
import { Box, Grid, Popover } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useState } from 'react';

import {
  WARRBOTS_APP_URL,
  WARRCHIRP_APP_URL,
  WARRINSIGHTS_APP_URL,
  WARRINVOICE_APP_URL,
  WARRQUEUE_APP_URL,
} from 'config';

import { AppItem } from './AppItem';

const APPS = [
  {
    iconId: 'warrqueue_app.svg',
    title: 'WarrQueue',
    route: WARRQUEUE_APP_URL,
  },
  {
    iconId: 'warrbots_app.svg',
    title: 'WarrBots',
    route: WARRBOTS_APP_URL,
  },
  {
    iconId: 'warrchirp_app.svg',
    title: 'WarrChirp',
    route: WARRCHIRP_APP_URL,
  },
  {
    iconId: 'warrinsights_app.svg',
    title: 'WarrInsights',
    route: WARRINSIGHTS_APP_URL,
  },
  {
    iconId: 'warrinvoice_app.svg',
    title: 'WarrInvoice',
    route: WARRINVOICE_APP_URL,
  },
];

const AppSelector = (): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const appsToShow = APPS.filter(app => app.route !== WARRCHIRP_APP_URL);

  return (
    <>
      <IconButton sx={{ color: theme => theme.palette.common.white }} onClick={handleClick}>
        <AppsIcon />
      </IconButton>
      <Popover
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box sx={{ paddingX: '30px', paddingY: '40px', maxWidth: '363px' }}>
          <Grid container columns={3} spacing="20px" rowSpacing="30px">
            {appsToShow.map(app => (
              <Grid item xs={1} key={app.iconId}>
                <AppItem
                  onClose={handleClose}
                  iconId={app.iconId || ''}
                  title={app.title || ''}
                  route={app.route || ''}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Popover>
    </>
  );
};

export default AppSelector;
